"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdatedInputsBasedOnCatalogType = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _meta = require("./meta");
var _App = require("../App/App.config");
var _graphqlTypes = require("../_types/graphql-types");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getUpdatedInputsBasedOnCatalogType = function getUpdatedInputsBasedOnCatalogType(productInputs) {
  var isAemEditMode = (0, _meta.getWcmmode)() === 'edit';
  var isBrowser = typeof window !== 'undefined';

  //In order to populate the data for the components like Dynamic product table, related product caurosel
  // and related product right rail  in authoring site passing the catalogType based on the applications uses this component.
  var path = isBrowser ? window.location.href : '';
  return productInputs.map(function (product) {
    return _objectSpread(_objectSpread({}, product), {}, {
      catalogType: isAemEditMode && path !== null && path !== void 0 && path.includes(_App.PERFORMANCE_MATERIALS_PATH) ? _graphqlTypes.CatalogType.Pm : _graphqlTypes.CatalogType.Sial
    });
  });
};
exports.getUpdatedInputsBasedOnCatalogType = getUpdatedInputsBasedOnCatalogType;